exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input-group .form-control[_v-6bcad522]{font-family:Open Sans;font-size:12px}.input-group[_v-6bcad522]{margin-left:25px}.btn-blue[_v-6bcad522]{padding:5px 12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-6bcad522&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/pages/Admin/Admin-products.vue
// module id = 440
// module chunks = 0